import stickybits from "stickybits"

window.stickybits = stickybits
